import React from 'react';

import { formatLinkBlockToUrl } from '$utilities/format';
import { isLocalURL } from '$utilities/browser';
import { usePage } from '$contexts/page.jsx';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/modules.d.ts').PanelBasicInlineBlock}
 */

const PanelBasicInline = ({
    buttons,
    id,
    text,
    title
}) => {
    const { page } = usePage();

    return (
        <section className='col-padding w-full'>
            <div className='px-16 pt-24 pb-16 rounded-lg flex-grow border border-border-default'>
                <h2 className='type-style-sans-h1 w-full md:w-7/12'>
                    {title}
                </h2>
                {text && (
                    <p className='type-style-sans-h3 mt-8 w-full sm:w-7/12 md:w-5/12'>
                        {text}
                    </p>
                )}
                {buttons?.length > 0 && (
                    <div className='mt-40 flex flex-wrap gap-x-8'>
                        {buttons.map((button, idx) => {
                            const isCtaLinkLocal = isLocalURL(formatLinkBlockToUrl(button.ctaLink));

                            return (
                                <React.Fragment key={idx}>
                                    {button.ctaMobileUrlOverride ? (
                                        <>
                                            <a
                                                className={`sm:hidden ${idx === 0 ? 'button-primary-xl' : 'button-outcome-xl'}`}
                                                data-analytics-action='click'
                                                data-analytics-context={title}
                                                data-analytics-destination={button.ctaMobileUrlOverride}
                                                data-analytics-id={`${page?.id}_${id}_panel_basic_inline_cta_${idx}`}
                                                data-analytics-label={button.ctaLabel}
                                                data-analytics-location='modules'
                                                data-analytics-module='panel_basic_inline_cta'
                                                href={button.ctaMobileUrlOverride}
                                                rel='noreferrer'
                                                target='_blank'>
                                                {button.ctaLabel}
                                            </a>
                                            <a
                                                className={`hidden sm:inline-block ${idx === 0 ? 'button-primary-xl' : 'button-outcome-xl'}${button.ctaCssClass ? ' ' + button.ctaCssClass : ''}`}
                                                data-analytics-action='click'
                                                data-analytics-context={title}
                                                data-analytics-destination={formatLinkBlockToUrl(button.ctaLink)}
                                                data-analytics-id={`${page?.id}_${id}_panel_basic_inline_cta_${idx}`}
                                                data-analytics-label={button.ctaLabel}
                                                data-analytics-location='modules'
                                                data-analytics-module='panel_basic_inline_cta'
                                                href={formatLinkBlockToUrl(button.ctaLink)}
                                                rel={isCtaLinkLocal ? undefined : 'noreferrer'}
                                                target={isCtaLinkLocal ? undefined : '_blank' }>
                                                {button.ctaLabel}
                                            </a>
                                        </>
                                    ) : (
                                        <a
                                            className={`${idx === 0 ? 'button-primary-xl' : 'button-outcome-xl'}${button.ctaCssClass ? ' ' + button.ctaCssClass : ''}`}
                                            data-analytics-action='click'
                                            data-analytics-context={title}
                                            data-analytics-destination={formatLinkBlockToUrl(button.ctaLink)}
                                            data-analytics-id={`${page?.id}_${id}_panel_basic_inline_cta_${idx}`}
                                            data-analytics-label={button.ctaLabel}
                                            data-analytics-location='modules'
                                            data-analytics-module='panel_basic_inline_cta'
                                            href={formatLinkBlockToUrl(button.ctaLink)}
                                            rel={isCtaLinkLocal ? undefined : 'noreferrer'}
                                            target={isCtaLinkLocal ? undefined : '_blank' }>
                                            {button.ctaLabel}
                                        </a>
                                    )}
                                </React.Fragment>
                            );
                        })}
                    </div>
                )}
            </div>
        </section>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default PanelBasicInline;
